import PropTypes from 'prop-types'

export const sizePropTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export type Theme = Record<string, string>

export type WidthType =  // n/12th of local width
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '1of2'
  | '1of3'
  | '1of4'
  | '2of3' // n/12th of root grid width (excluding 16px gutter)
  | '3of4'
  | '1root'
  | '2root'
  | '3root'
  | '4root'
  | '5root'
  | '6root'
  | '7root'
  | '8root'
  | '9root'
  | '10root'
  | '11root'
  | '12root'
  | '1of2root'
  | '1of3root'
  | '1of4root'
  | '2of3root' // sizes from T-Shirt scale (variables.size_*)
  | '3of4root'
  | 'xs'
  | 's'
  | 'sm'
  | 'm'
  | 'l'
  | 'xl' // take maximum space available (may shrink other elements, may not work outside flexbox)
  | 'xxl' // fill any available space (won't shrink other elements)
  | 'max' // grow with the content size
  | 'fill' // height is defined through styles
  | 'grow'
  | 'static'

export type HeightType =  // sizes from T-Shirt scale (variables.size_*)
  | 'xs'
  | 's'
  | 'sm'
  | 'm'
  | 'l'
  | 'xl'
  | 'xxl' // take maximum space available (may shrink other elements, may not work outside flexbox)
  | 'xxxl' // grow with the content size
  | 'max' // height is defined through styles
  | 'grow'
  | 'static'

export type GutterType = 'none' | 'xxs' | 'xs' | 's' | 'sm' | 'm'

export type AlignType = 'top' | 'center' | 'bottom' | 'baseline' | 'stretch'
export type JustifyType = 'left' | 'center' | 'right' | 'spaceBetween'

export type SizeProps = {
  width?: WidthType
  height?: HeightType
}
